import React from 'react';

const Reports: React.FC = () => {
	return <div className="reports-container">Reports component</div>;
};

export default Reports;
